import axios from './index';

/**
 * APIs（操作人列表，用于导出/日志等筛选）
 */
export function operators(params: OperatorsParams) {
    return axios<PageResType<OperatorsResponse>>('/v1/operators', {
        method: 'get',
        params,
    });
}

/**
 * Types
 */
import { PageResType } from '@/typings/common';

export type OperatorsParams = {
    limit?: number | string;
    page?: number | string;
    model?: string;
};

export type OperatorsResponse = {
    account: {
        id: string;
        name: string;
        status?: number;
    };
    account_id: string;
    created_at: string;
    deleted_at?: string;
    id: string;
    model?: string;
    updated_at: string;
};
